/**
 * Album image pixel dimensions stored in Media.metadata (JSON) and exposed on API DTOs.
 * Used for PhotoSwipe initial layout so aspect ratio is correct before decode.
 */

export const MEDIA_IMAGE_PIXEL_WIDTH_KEY = "imagePixelWidth" as const
export const MEDIA_IMAGE_PIXEL_HEIGHT_KEY = "imagePixelHeight" as const

/** Upper bound aligned with common max texture / decode limits. */
export const MEDIA_IMAGE_PIXEL_DIM_MAX = 32_768

export function isAlbumImagePixelDimension(n: unknown): n is number {
  return (
    typeof n === "number" &&
    Number.isInteger(n) &&
    n > 0 &&
    n <= MEDIA_IMAGE_PIXEL_DIM_MAX
  )
}

export function readAlbumImagePixelSizeFromMetadata(
  metadata: unknown,
): { width: number; height: number } | null {
  if (!metadata || typeof metadata !== "object") return null
  const o = metadata as Record<string, unknown>
  const w = o[MEDIA_IMAGE_PIXEL_WIDTH_KEY]
  const h = o[MEDIA_IMAGE_PIXEL_HEIGHT_KEY]
  if (!isAlbumImagePixelDimension(w) || !isAlbumImagePixelDimension(h)) {
    return null
  }
  return { width: w, height: h }
}

export function parseMultipartAlbumImagePixelDimensions(formData: FormData): {
  width: number
  height: number
} | null {
  const wRaw = formData.get("imagePixelWidth")
  const hRaw = formData.get("imagePixelHeight")
  const w = typeof wRaw === "string" ? Number.parseInt(wRaw.trim(), 10) : NaN
  const h = typeof hRaw === "string" ? Number.parseInt(hRaw.trim(), 10) : NaN
  if (!isAlbumImagePixelDimension(w) || !isAlbumImagePixelDimension(h)) return null
  return { width: w, height: h }
}

export function albumImagePixelMetadataRecord(size: {
  width: number
  height: number
}): Record<string, number> {
  return {
    [MEDIA_IMAGE_PIXEL_WIDTH_KEY]: size.width,
    [MEDIA_IMAGE_PIXEL_HEIGHT_KEY]: size.height,
  }
}
